import { Link } from 'gatsby'
import styled, { css } from 'styled-components'
import { Media, mbSize } from '../../theme'

export const HeaderWrapper = styled.div<{ $showMobileNav: boolean; $showTopBanner: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  width: 100%;
  background: #282828cc;
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(30px);
  z-index: 10000;
  position: fixed;
  top: ${({ $showTopBanner }) => ($showTopBanner ? '48px' : '0')};
  margin-bottom: -60px;
  min-width: 1280px;
  ${Media.lessThan(Media.small)} {
    margin-bottom: unset;
    position: fixed;
    top: unset;
    height: ${mbSize(120)};
    padding: 0 ${mbSize(40)};
    background: ${({ $showMobileNav }) => ($showMobileNav ? '#181818' : '#282828cc')};
    min-width: unset;
  }
`

export const HeaderLeftWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  ${Media.lessThan(Media.small)} {
    padding-left: unset;
  }
`

export const HeaderRightWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-right: 20px;
  height: 100%;
  ${Media.lessThan(Media.xxxlarge)} {
    padding-right: 10px;
  }
  ${Media.lessThan(Media.small)} {
    padding-right: unset;
  }
`

export const UserActionWrapper = styled.div`
  display: flex;
  align-items: center;
  ${Media.lessThan(Media.small)} {
    display: none;
  }
`

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 65px 0 30px;
  height: 100%;
  img {
    width: 140px;
    height: 30px;
  }
  ${Media.lessThan(Media.xxxlarge)} {
    padding: 0 20px 0 20px;
  }
  ${Media.lessThan(Media.small)} {
    padding: unset;
    width: ${mbSize(280)};
    height: ${mbSize(60)};
    img {
      width: ${mbSize(280)};
      height: ${mbSize(60)};
    }
  }
`

export const NavBarWrapper = styled.div`
  display: flex;
  height: fit-content;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  ${Media.lessThan(Media.small)} {
    display: none;
  }
`

const commonLink = css<{ $isActive: boolean }>`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  height: 60px;
  padding: 0 13px;
  transition: background 0.3s;
  &:hover {
    background: #222222;
    border-bottom: 2px solid #f3512b;
  }
  &:nth-child(-n + 6) {
    margin-right: 14px;
  }
  ${({ $isActive }) =>
    $isActive &&
    css`
      border-bottom: 2px solid #f3512b;
    `}
  ${Media.lessThan(Media.xxxlarge)} {
    padding: 0 5px;
  }
`

export const NavLink = styled(Link)<{ $isActive: boolean }>`
  ${commonLink}
`

export const HeaderButton = styled.button<{
  $horizontalPadding: number
  $height: number
  $isRegister?: boolean
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ $horizontalPadding }) => `0 ${$horizontalPadding}px`};
  height: ${({ $height }) => `${$height}px`};
  border-radius: 18px;
  border: ${({ $isRegister }) => ($isRegister ? 'unset' : '1px solid #99999966')};
  color: #ffffff;
  transition: all 0.3s;
  font-size: 16px;
  background: ${({ $isRegister }) =>
    $isRegister ? 'linear-gradient(172.95deg, #E8482B 5.19%, #E8482B 85.35%)' : '#66666666'};
  margin-left: ${({ $isRegister }) => (!$isRegister ? '2px' : 'unset')};
  white-space: nowrap;
  &.register {
    display: none;
  }
  @media (max-width: 1920px) {
    &.register {
      display: flex;
      margin-left: 25px;
    }
  }
  &:hover {
    background: ${({ $isRegister }) =>
      $isRegister ? 'linear-gradient(172.95deg, #F3512B 5.19%, #E9743C 85.35%)' : '#F3512B'};
    border-color: #f3512b;
    color: #fff;
  }
`

export const EmailInputWrapper = styled.div<{ $isFocus: boolean }>`
  width: 320px;
  height: 40px;
  border-radius: 20px;
  background-color: #222222cc;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-left: 20px;
  transition: all 0.3s;
  border: 1px solid ${({ $isFocus }) => ($isFocus ? '#f3512b' : 'transparent')};
  > a {
    margin-right: 6px;
  }
  @media (max-width: 1920px) {
    display: none;
  }
`

export const EmailInput = styled.input`
  font-family: MarkPro;
  border-radius: 20px;
  padding: 0 10px 0 20px;
  border: none;
  width: 100%;
  height: 100%;
  background-color: transparent;
  outline: none;
  color: #ffffff;
  flex: 1;
`

export const NavDropDownWrapper = styled.div<{ $isActive: boolean; $left: number }>`
  ${commonLink}
  cursor: pointer;
  position: relative;
  > div.navDropDown {
    visibility: hidden;
    position: absolute;
    left: ${({ $left }) => `${$left}px`};
    top: 60px;
    background: #222222;
  }
  &:hover {
    div.navDropDown {
      visibility: visible;
    }
  }
`

export const NavDropDownItem = styled.div<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  height: 42px;
  padding: 0 20px;
  color: #fff;
  width: 100%;
  white-space: nowrap;
  transition: background 0.3s;
  background: ${({ $isActive }) => ($isActive ? '#181818' : '#222222')};
  &:hover {
    background: #181818;
    border-bottom: 2px solid #f3512b;
  }
`

export const LocaleMenuWrapper = styled.div<{ $show: boolean }>`
  height: 60px;
  position: relative;
  cursor: pointer;
  margin-left: 10px;
  color: #cccccc;
  user-select: none;
  font-size: 14px;
  transition: all 0.3s;
  background: ${({ $show }) => ($show ? '#222222' : 'transparent')};
  z-index: 10000;
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(28)};
    height: ${mbSize(120)};
  }
`

export const LocaleItemsWrapper = styled.div<{ $show: boolean }>`
  width: 100%;
  visibility: ${({ $show }) => ($show ? 'visible' : 'hidden')};
  position: absolute;
  left: 0;
  top: 100%;
  background: #222222;
`

export const LocaleItem = styled.a<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  padding-left: 16px;
  width: 100%;
  height: 36px;
  color: #fff;
  &:hover {
    background: #181818;
  }
  background: ${({ $isActive }) => ($isActive ? '#181818' : 'unset')};
  ${Media.lessThan(Media.small)} {
    padding-left: ${mbSize(32)};
  }
`

export const CurrentLocaleItem = styled.div<{ $show: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-left: 16px;
  > svg {
    margin: 0 12px 0 15px;
    transition: all 0.3s;
    transform: ${({ $show }) => ($show ? 'rotate(180deg)' : 'rotate(0deg)')};
  }
  ${Media.lessThan(Media.small)} {
    padding-left: ${mbSize(32)};
    > svg {
      margin: 0 ${20} 0 ${mbSize(22)};
      width: ${mbSize(28)};
      height: ${mbSize(14)};
    }
  }
`

export const MobileMenuWrapper = styled.div`
  display: none;
  z-index: 10000;
  ${Media.lessThan(Media.small)} {
    display: block;
    margin-left: ${mbSize(40)};
  }
`

export const MenuIconWrapper = styled.div`
  > svg {
    width: ${mbSize(33)};
    height: ${mbSize(24)};
  }
`

export const MobileMenuItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: ${mbSize(120)};
  left: 0;
  background: #252525;
  padding: ${mbSize(30)} ${mbSize(48)};
  width: 100%;
`

export const commonMobileMenuLink = css`
  font-size: ${mbSize(28)};
  padding: ${mbSize(24)} ${mbSize(8)};
  color: #ffffff;
`

export const MobileMenuLink = styled(Link)`
  ${commonMobileMenuLink}
`

export const MobileSecondMenuWrapper = styled.div``

export const MobileSecondMenuTitle = styled.div<{ $isActive: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${commonMobileMenuLink}
  > svg {
    transition: all 0.3s;
    transform: ${({ $isActive }) => ($isActive ? 'rotate(180deg)' : 'rotate(0deg)')};
  }
`

export const MobileMenuSecondLink = styled.div`
  font-size: ${mbSize(24)};
  padding: ${mbSize(10)} ${mbSize(8)};
  color: #ffffff;
`

export const MobileSecondMenuContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 50%);
  margin-left: ${mbSize(12)};
  padding-bottom: ${mbSize(30)};
`

export const SupportDropDownWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 20px;
`

export const SupportDownloadWrapper = styled(Link)`
  position: relative;
  width: 270px;
  height: 160px;
  border-radius: 10px;
  background: linear-gradient(
    285.35deg,
    rgba(243, 81, 43, 0.1) 12.22%,
    rgba(51, 51, 51, 0.2) 89.84%
  );
  padding-left: 20px;
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 10px;
    padding: 1px;
    background: linear-gradient(180deg, rgba(51, 51, 51, 0.7) 0%, rgba(245, 92, 30, 0.2) 100%);
    mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask-composite: exclude;
  }
  &:hover {
    background: linear-gradient(180deg, #333333 0%, rgba(243, 81, 43, 0.6) 100%);
  }
  ${Media.lessThan(Media.small)} {
    display: flex;
    align-items: center;
    width: ${mbSize(650)};
    height: ${mbSize(80)};
    border-radius: ${mbSize(10)};
    margin-bottom: ${mbSize(22)};
    padding-left: ${mbSize(30)};
  }
`

export const FreeIcon = styled.div`
  background: #f3512b;
  position: absolute;
  top: 0;
  right: 0;
  padding: 3px 20px;
  width: fit-content;
  border-radius: 0px 10px 0px 10px;
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  ${Media.lessThan(Media.small)} {
    padding: ${mbSize(4.5)} ${mbSize(30)};
    border-radius: 0px ${mbSize(15)} 0px ${mbSize(15)};
    font-size: ${mbSize(24)};
  }
`

export const DownloadTitle = styled.div`
  font-size: 16px;
  font-weight: 800;
  line-height: 20.28px;
  margin-top: 30px;
  color: #fff;
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(28)};
    margin-top: unset;
  }
`

export const DownloadItem = styled.div`
  display: flex;
  color: #fff;
  margin-top: 10px;
  font-size: 14px;
  font-weight: 400;
  line-height: 17.75px;
  > svg {
    margin-right: 10px;
  }
`

export const SupportCenterDivider = styled.div`
  width: 1px;
  height: 180px;
  margin: 0 30px 0 20px;
  background: #333333;
`

export const SupportRightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const SupportItemWrapper = styled.div`
  display: flex;
  border-bottom: 1px solid #333333;
  padding-bottom: 20px;
  margin-bottom: 18px;
`

export const SupportColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const SupportItem = styled.a`
  padding: 10px;
  width: 100%;
  min-width: 180px;
  font-size: 14px;
  font-weight: 400;
  transition: background 0.3s;
  box-sizing: border-box;
  border-bottom: 2px solid transparent;
  color: #fff;
  &:hover {
    border-bottom: 2px solid #f3512b;
    background: #181818;
  }
`

export const SupportContact = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  color: #999999;
  transition: color 0.3s;
  svg {
    margin-right: 10px;
  }
  &:hover {
    color: #fff;
  }
`

export const Console = styled.a`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  height: 60px;
  padding: 0 13px;
  transition: background 0.3s;
  margin-right: 15px;
  &:hover {
    background: #222222;
  }
`

export const UserMenuWrapper = styled.div<{ $show: boolean }>`
  position: relative;
  cursor: pointer;
  margin-right: 20px;
  color: #fff;
  user-select: none;
  font-size: 14px;
  transition: all 0.3s;
  background: ${({ $show }) => ($show ? '#222222' : 'transparent')};
  z-index: 10000;
`

export const UserInfoItem = styled.div<{ $show: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  height: 60px;
  padding: 0 10px;
  > svg {
    margin-left: 13px;
    transition: all 0.3s;
    transform: ${({ $show }) => ($show ? 'rotate(180deg)' : 'rotate(0deg)')};
  }
`

export const UserItemsWrapper = styled.div<{ $show: boolean }>`
  visibility: ${({ $show }) => ($show ? 'visible' : 'hidden')};
  position: absolute;
  left: 0;
  top: 100%;
  background: #222222;
  min-width: 100%;
`

export const UserItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0 20px;
  width: fit-content;
  min-width: 100%;
  height: 36px;
  color: #fff;
  transition: background 0.3s;
  &:hover {
    background: #181818;
    border-bottom: 2px solid #f3512b;
  }
  ${Media.lessThan(Media.small)} {
    width: ${mbSize(200)};
    padding-left: ${mbSize(32)};
  }
`

export const UserAvatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3512b;
  width: 30px;
  height: 30px;
  border-radius: 30px;
  margin-right: 14px;
`

export const Logout = styled.div`
  display: flex;
  align-items: center;
  padding-left: 20px;
  width: 100%;
  height: 48px;
  border-top: 1px solid #333333;
  transition: background 0.3s;
  margin-top: 10px;
  &:hover {
    background: #181818;
  }
`
